import * as Yup from "yup";

const NATIONALITY = {
  DOMESTIC: "domestic",
  FOREIGNER: "foreigner",
};

export const initialValues = {
  titleId: null,
  name: null,
  surName: null,
  nameEn: null,
  surNameEn: null,
  nickName: null,
  nickNameEn: null,
  dateOfBirth: null,
  genderId: null,
  employeeNationality: NATIONALITY.DOMESTIC,
  identificationNo: null,
  raceId: null,
  passportNo: null,
  passportIssueCountryId: null,
  passportIssueDate: null,
  passportExpireDate: null,
  // * Visa
  visaTypeId: null,
  visaNo: null,
  visaIssueCountryId: null,
  visaIssueDate: null,
  visaExpireDate: null,
  // * Work Permit
  workPermitNo: null,
  workPermitIssueDate: null,
  workPermitExpireDate: null,
  nationalityId: null,
  religionId: null,
  maritalStatusId: null,
  militaryStatusId: null,
  bloodGroupId: null,
  weight: null,
  height: null,
  remark: null,
};

const EmployeeInfoGeneralSchema = Yup.object().shape({
  titleId: Yup.string().required("Please select title."),
  name: Yup.string().required("Please enter name."),
  surName: Yup.string().required("Please enter surname."),
  nameEn: Yup.string().required("Please enter name."),
  surNameEn: Yup.string().required("Please enter surname."),
  // dateOfBirth: Yup.string().required("Please select date of birth."),
  // genderId: Yup.string().required("Please select gender"),
  // employeeNationality: Yup.string().required("Please select nationality."),
  // // raceId: Yup.string().required("Please select race."),
  // // nationalityId: Yup.string().required("Please select nationality."),
  // religionId: Yup.string().required("Please select religion."),
  // maritalStatusId: Yup.string().required("Please select marital status."),
  // militaryStatusId: Yup.string().required("Please select military status."),
  // bloodGroupId: Yup.string().required("Please blood group."),
  // weight: Yup.string().required("Please enter weight."),
  // height: Yup.string().required("Please enter height."),
  // passportNo: Yup.string().when("employeeNationality", {
  //   is: NATIONALITY.FOREIGNER,
  //   then: (s) => s.required("Please enter passport No."),
  // }),
  // passportIssueCountryId: Yup.string().when("employeeNationality", {
  //   is: NATIONALITY.FOREIGNER,
  //   then: (s) => s.required("Please select passport issuing country."),
  // }),
  // passportExpireDate: Yup.string().when("employeeNationality", {
  //   is: NATIONALITY.FOREIGNER,
  //   then: (s) => s.required("Please select passport expire date."),
  // }),

  // visaTypeId: Yup.string().when("employeeNationality", {
  //   is: NATIONALITY.FOREIGNER,
  //   then: (s) => s.required("Please select visa type."),
  // }),
  // visaNo: Yup.string().when("employeeNationality", {
  //   is: NATIONALITY.FOREIGNER,
  //   then: (s) => s.required("Please enter visa No."),
  // }),
  // visaIssueCountryId: Yup.string().when("employeeNationality", {
  //   is: NATIONALITY.FOREIGNER,
  //   then: (s) => s.required("Please select visa issuing country."),
  // }),
  // visaExpireDate: Yup.string().when("employeeNationality", {
  //   is: NATIONALITY.FOREIGNER,
  //   then: (s) => s.required("Please select visa expire date."),
  // }),

  // workPermitNo: Yup.string().when("employeeNationality", {
  //   is: NATIONALITY.FOREIGNER,
  //   then: (s) => s.required("Please enter work permit No."),
  // }),
  // workPermitExpireDate: Yup.string().when("employeeNationality", {
  //   is: NATIONALITY.FOREIGNER,
  //   then: (s) => s.required("Please select work permit expire date."),
  // }),
});

export default EmployeeInfoGeneralSchema;
